<app-mat-spinner-overlay *ngIf="isLoading"></app-mat-spinner-overlay>

<div class="duplicate-document-report-page">
  <div class="header-container">
    <h1 class="page-title">Duplicate Document Report</h1>
    <p class="page-subtitle">
      Click on a duplicate count to view repeated document numbers.
    </p>
  </div>

  <div class="document-card-grid" *ngIf="summaryDocuments.length; else noDataFound">
    <div
      class="document-card"
      *ngFor="let documentRow of summaryDocuments"
      [style.--doc-color]="getDocumentColor(documentRow.Doc_Name)"
    >
      <div class="card-header">
        <div class="doc-icon-wrapper">
          <i class="fas" [ngClass]="getDocumentIcon(documentRow.Doc_Name)"></i>
        </div>
        <h3 class="document-name">{{ documentRow.Doc_Name || "-" }}</h3>
      </div>

      <div class="document-count-row">
        <span class="count-label">Total Duplicates</span>
        <button
          type="button"
          class="count-badge"
          (click)="onDocumentCountClick(documentRow)"
          title="View detailed breakdown"
        >
          {{ documentRow.Duplicate_Count || 0 }}
        </button>
      </div>
    </div>
  </div>

  <ng-template #noDataFound>
    <div class="empty-state">
      <i class="fas fa-folder-open"></i>
      No duplicate document data available at this time.
    </div>
  </ng-template>
</div>

<!-- Second Modal: Document Details -->
<div
  *ngIf="showDetailModal"
  class="modal fade in show"
  tabindex="-1"
  role="dialog"
  style="display: block; background: rgba(0, 0, 0, 0.5)"
>
  <div class="modal-dialog modal-md modal-dialog-centered duplicate-doc-modal" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fas fa-list-ul mr-2"></i>
          {{ selectedDocumentName }} Breakdown
        </h5>
        <button type="button" class="close modal-close-btn" (click)="closeDetailModal()">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div class="table-responsive">
          <mat-table [dataSource]="detailDataSource" style="max-width: 100%; overflow: auto;">
            <ng-container matColumnDef="srNo">
              <mat-header-cell *matHeaderCellDef style="max-width: 3.75rem">#</mat-header-cell>
              <mat-cell *matCellDef="let row; let i = index" style="max-width: 3.75rem">
                {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="docNumber">
              <mat-header-cell *matHeaderCellDef>Document Number</mat-header-cell>
              <mat-cell *matCellDef="let detailRow">
                <strong>{{
                  detailRow.KYC_DocNumber ||
                    detailRow.Doc_No ||
                    detailRow.Document_No ||
                    detailRow.DocNumber ||
                    detailRow.KYC_Doc_No ||
                    "-"
                }}</strong>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="repeats">
              <mat-header-cell *matHeaderCellDef>Repeats</mat-header-cell>
              <mat-cell *matCellDef="let detailRow">
                <span class="badge-repeat">
                  {{
                    detailRow.Total_count ||
                      detailRow.Duplicate_Count ||
                      detailRow.Repeat_Count ||
                      detailRow.Count ||
                      detailRow.DuplicateCount ||
                      0
                  }} Times
                </span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="action">
              <mat-header-cell *matHeaderCellDef style="max-width: 6.25rem">Action</mat-header-cell>
              <mat-cell *matCellDef="let detailRow" style="max-width: 6.25rem">
                <button
                  type="button"
                  class="action-btn"
                  (click)="onViewCustomerDetails(detailRow)"
                  title="View Customers"
                >
                  <i class="fas fa-eye"></i>
                </button>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="['srNo', 'docNumber', 'repeats', 'action']"></mat-header-row>
            <mat-row *matRowDef="let row; columns: ['srNo', 'docNumber', 'repeats', 'action']"></mat-row>
          </mat-table>
          <div *ngIf="!selectedDocumentDetails.length" class="text-center py-5">
            <i class="fas fa-info-circle mr-2"></i> No details found.
          </div>
        </div>
        <mat-paginator
          #paginatorRef
          [pageSizeOptions]="[20, 50]"
          showFirstLastButtons
        ></mat-paginator>
      </div>
    </div>
  </div>
</div>

<!-- Third Modal: Customer Details -->
<div
  *ngIf="showCustomerDetailModal"
  class="modal fade in show"
  tabindex="-1"
  role="dialog"
  style="display: block; background: rgba(0, 0, 0, 0.6)"
>
  <div class="modal-dialog modal-lg modal-dialog-centered duplicate-doc-modal" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fas fa-users mr-2"></i>
          Linked Customers ({{ selectedDocNumber }})
        </h5>
        <button type="button" class="close modal-close-btn" (click)="closeCustomerDetailModal()">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div class="table-responsive">
          <mat-table [dataSource]="customerDataSource" style="max-width: 100%; overflow: auto;">
            <ng-container matColumnDef="srNo">
              <mat-header-cell *matHeaderCellDef style="max-width: 3.125rem">#</mat-header-cell>
              <mat-cell *matCellDef="let row; let i = index" style="max-width: 3.125rem">
                {{ paginatorRef1.pageIndex * paginatorRef1.pageSize + (i + 1) }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="customerName">
              <mat-header-cell *matHeaderCellDef>Customer Name</mat-header-cell>
              <mat-cell *matCellDef="let customerRow">{{ customerRow.CustomerName || customerRow.Customer_Name || "-" }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="phoneNo">
              <mat-header-cell *matHeaderCellDef>Phone No</mat-header-cell>
              <mat-cell *matCellDef="let customerRow">{{ customerRow.Customer_PhoneNo || customerRow.PhoneNo || "-" }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="kycDoc">
              <mat-header-cell *matHeaderCellDef>KYC Doc</mat-header-cell>
              <mat-cell *matCellDef="let customerRow">{{ customerRow.KYC_DocNumber || "-" }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="document">
              <mat-header-cell *matHeaderCellDef>Document</mat-header-cell>
              <mat-cell *matCellDef="let customerRow">{{ customerRow.Doc_Name || "-" }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="address">
              <mat-header-cell *matHeaderCellDef>Address</mat-header-cell>
              <mat-cell *matCellDef="let customerRow" class="address-col">{{ customerRow.Address || "-" }}</mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="['srNo', 'customerName', 'phoneNo', 'kycDoc', 'document', 'address']"></mat-header-row>
            <mat-row *matRowDef="let row; columns: ['srNo', 'customerName', 'phoneNo', 'kycDoc', 'document', 'address']"></mat-row>
          </mat-table>
          <div *ngIf="!customerDetails.length" class="text-center py-5">
            <i class="fas fa-user-slash mr-2"></i> No customer details found.
          </div>
        </div>
        <mat-paginator
          #paginatorRef1
          [pageSizeOptions]="[20, 50]"
          showFirstLastButtons
        ></mat-paginator>
      </div>
    </div>
  </div>
</div>
